var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquareArrowUp = function SvgSquareArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18,14V6c0-2.206-1.794-4-4-4H6c-2.206,0-4,1.794-4,4v8c0,2.206,1.794,4,4,4h8c2.206,0,4-1.794,4-4Zm-5.076-4.617c-.154.374-.52.617-.924.617h-1v3c0,.553-.447,1-1,1s-1-.447-1-1v-3h-1c-.404,0-.77-.243-.924-.617-.155-.374-.069-.804.217-1.09l2-2c.195-.195.451-.293.707-.293s.512.098.707.293l2,2c.286.286.372.716.217,1.09Z",
    strokeWidth: 0,
    fill: "currentColor"
  })));
};
export default SvgSquareArrowUp;